import { uniq } from 'lodash'
import { Page } from '../../../models/util.model'
import { Movement } from '../models/movement.entity'
import { MovementListingKeys } from '../models/movement-listing.model'

/**
 * Parse movement page keys
 * @param page - the movements page
 * @returns the page listing keys
 */
export function parseMovementPageKeys(
  page: Page<Movement>,
): MovementListingKeys {
  return page.data.reduce<MovementListingKeys>(
    (acc, r) => parseMovementKeys(r, acc),
    {},
  )
}

/**
 * Parse movement keys
 * @param movement - the movement
 * @param keys - the keys already loaded
 * @returns the movement listing keys
 */
export function parseMovementKeys(
  movement: Movement,
  keys: MovementListingKeys = {},
): MovementListingKeys {
  const goodsReceivesRefs = uniq([
    ...(keys['goodsReceivesRefs'] || []),
    ...(movement.reason === 'RECEIVE' && movement.order?.orderNumber
      ? [movement.order?.orderNumber]
      : []),
  ])
  const reasonIds = uniq([
    ...(keys['reasonIds'] || []),
    ...(movement.reason ? [movement.reason] : []),
  ])
  const userIds = uniq([
    ...(keys['userIds'] || []),
    ...(movement.userId ? [movement.userId] : []),
  ])
  const warehouseIds = uniq([
    ...(keys['warehouseIds'] || []),
    ...(movement.warehouseId ? [movement.warehouseId] : []),
  ])

  return {
    goodsReceivesRefs,
    reasonIds,
    userIds,
    warehouseIds,
  }
}
